export const formatSizeUnits = (bytes, decimal = 2) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  if (bytes === 0) return '0 Byte'
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)))
  return (
    Math.round(bytes / Math.pow(1024, i), 2).toFixed(decimal) + ' ' + sizes[i]
  )
}

export const generateUrlWaterMarker = (url, archivoId, token, mensaje) => {
  const urlWaterMarker = new URL(
    `${url}/api/v1/ms-files/ver/archivo-con-marca-agua/${archivoId}/${token}/${mensaje}`
  )
  return urlWaterMarker.href
}
